import React, { useState, useEffect, useMemo } from "react";
import {
  Box,
  Grid,
  TextField,
  Typography,
  CardContent,
  useTheme,
  useMediaQuery,
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAllSipListRequest,
  getSipInstallmentsRequest,
  changeLuckyDrawEligibilityRequest,
} from "../../../redux/SipPlan/SipPlanSlice";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import TableCompo from "../Table/TableCompo";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { useLocation } from "react-router-dom";
import { getAppConfig } from "../../../redux/Configuration/configurationSlice";
import { Switch } from "@mui/material";

export default function SipSubscriberList() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const dispatch = useDispatch();
  const { allSipList, loading, sipInstallments, total } = useSelector(
    (state) => state.sipplan
  );
  const taxType = useSelector(
    (state) => state?.appConfig?.configData?.taxtype || "GST"
  );
  console.log("taxType", taxType);
  useEffect(() => {
    dispatch(getAppConfig());
  }, []);

  console.log("allSipList in SipPlan:", allSipList);
  console.log("sipInstallments:", sipInstallments);

  const [pagination, setPagination] = useState({ page: 0, limit: 10 });
  const [searchText, setSearchText] = useState("");

  const handleTableChange = (action, payload) => {
    switch (action) {
      case "search":
        setSearchText(payload.searchText || "");
        setPagination((prev) => ({ ...prev, page: 0 }));
        break;
      case "changePage":
        setPagination((prev) => ({ ...prev, page: payload.page }));
        break;
      case "changeRowsPerPage":
        setPagination({ page: 0, limit: payload.rowsPerPage });
        break;
      default:
        break;
    }
  };

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const sipId = searchParams.get("id");
  console.log("sipId", sipId);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [filterApplied, setFilterApplied] = useState(false);

  const [openDialog, setOpenDialog] = useState(false);
  const [selectedPlanId, setSelectedPlanId] = useState(null);
  useEffect(() => {
    const params = {
      page: pagination.page + 1,
      limit: pagination.limit,
      searchText,
    };

    if (sipId) params.id = sipId;

    dispatch(fetchAllSipListRequest(params));
  }, [dispatch, sipId, pagination, searchText]);

  const handleViewInstallments = (planId) => {
    setSelectedPlanId(planId);
    dispatch(getSipInstallmentsRequest(planId));
  };

  useEffect(() => {
    if (selectedPlanId) {
      setOpenDialog(true);
    }
  }, [selectedPlanId]);

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedPlanId(null);
  };

  const formatDateTime = (value) => {
    if (!value) return "N.A";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "N.A";
    return date.toLocaleString("en-IN", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });
  };

  const formatUpcomingWithDueDays = (item) => {
    if (item?.status === "PENDING") return "N.A";

    const pendingFromInstallments = (item?.installments || [])
      .filter((installment) => installment?.status === "PENDING")
      .sort(
        (a, b) =>
          Number(a?.installmentDate || 0) - Number(b?.installmentDate || 0)
      )?.[0]?.installmentDate;

    const pendingFromInstallmentDetails = (item?.sipInstallmentsDetails || [])
      .filter((installment) => installment?.status === "PENDING")
      .sort(
        (a, b) =>
          Number(a?.installmentDate || 0) - Number(b?.installmentDate || 0)
      )?.[0]?.installmentDate;

    const rawUpcomingDate =
      item?.upcomingInstallment ||
      pendingFromInstallments ||
      pendingFromInstallmentDetails ||
      item?.Upcoming ||
      item?.upcoming ||
      item?.nextInstallmentDate ||
      item?.nextUpcomingInstallmentDate ||
      item?.nextInstallment?.installmentDate;

    let upcomingDate = rawUpcomingDate ? new Date(rawUpcomingDate) : null;
    if (!upcomingDate || Number.isNaN(upcomingDate.getTime())) {
      const totalMonths = Number(item?.noOfMonths || 0);
      const paidInstallments = Number(item?.paidInstallments || 0);
      const hasPendingInstallments = totalMonths > paidInstallments;

      if (!hasPendingInstallments) return "N.A";

      const baseDateValue = item?.lastPaid || item?.createdAt;
      const baseDate = baseDateValue ? new Date(baseDateValue) : null;
      if (!baseDate || Number.isNaN(baseDate.getTime())) return "N.A";

      // Fallback: assume next installment is one month after last paid/created date.
      upcomingDate = new Date(baseDate);
      upcomingDate.setMonth(upcomingDate.getMonth() + 1);
    }

    const today = new Date();
    const todayStart = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate()
    );
    const upcomingStart = new Date(
      upcomingDate.getFullYear(),
      upcomingDate.getMonth(),
      upcomingDate.getDate()
    );
    const dayDiff = Math.round(
      (upcomingStart.getTime() - todayStart.getTime()) / (1000 * 60 * 60 * 24)
    );

    let dueText = "";
    if (dayDiff > 0) dueText = `Due in ${dayDiff} day${dayDiff > 1 ? "s" : ""}`;
    else if (dayDiff < 0) {
      const absDays = Math.abs(dayDiff);
      dueText = `Overdue by ${absDays} day${absDays > 1 ? "s" : ""}`;
    } else dueText = "Due today";

    return `${upcomingDate.toLocaleDateString()} (${dueText})`;
  };

  const handleLuckyDrawEligibilityChange = (sipId, luckyDrawEligibility) => {
    dispatch(
      changeLuckyDrawEligibilityRequest({
        sipId,
        luckyDrawEligibility,
      })
    );
  };

  // Convert and prepare all SIP data
  const sipData = Array.isArray(allSipList)
    ? allSipList
    : Array.isArray(allSipList?.data)
    ? allSipList.data
    : [];

  const dateFilteredSipData = useMemo(() => {
    if (!filterApplied || !startDate || !endDate) return sipData;
    return sipData.filter((item) => {
      const created = new Date(item.createdAt);
      return created >= new Date(startDate) && created <= new Date(endDate);
    });
  }, [sipData, filterApplied, startDate, endDate]);

  const handleFilter = () => {
    if (!startDate || !endDate) {
      alert("Please select both start and end dates");
      return;
    }
    setFilterApplied(true);
  };

  const displayData = dateFilteredSipData.map((item) => {
    const transaction = item?.transactions?.transactions ?? {};
    return {
      id: item._id,
      _id: item._id,
      createdAt: new Date(item.createdAt).toLocaleDateString(),
      name: `${item?.customerDetails?.firstName ?? ""} ${
        item?.customerDetails?.lastName ?? "N.A"
      }`,
      sipplanname: item?.sipplanDetails?.name ?? "N.A",
      choiceNumber:
        item?.choiceNumber !== undefined && item?.choiceNumber !== null
          ? item.choiceNumber
          : "N.A",
      serialNumber:
        item?.serialNumber !== undefined && item?.serialNumber !== null
          ? item.serialNumber
          : "N.A",
      phone: item?.customerDetails?.phone ?? "N.A",
      address: item?.customerDetails?.address?.[0]?.state ?? "N.A",
      metalPurity: item?.bullion?.metalName
      ? `${item.bullion.metalName} (${item.bullion.karat ?? "N.A"}K - ${item.bullion.purity ?? "N.A"})`
      : "Money" ?? "N.A",
      amount: Number(item.installmentAmount).toFixed(2) ?? "N.A",
      months: item.noOfMonths ?? "N.A",
      status: item.status ?? "N.A",
      logindetails:
        item?.customerDetails?.logindetails?.currentLoginAt ?? "N.A",
      weight: transaction?.weight ?? "N.A",
      paidInstallments: item.paidInstallments ?? "N.A",
      pending: Number(item.noOfMonths) - Number(item.paidInstallments),
      lastPaid: formatDateTime(item?.lastPaid),
      Upcoming: formatUpcomingWithDueDays(item),
      luckyDrawEligibility:
        item?.luckyDrawEligibility ??
        item?.luckyDrawDetails?.eligibility ??
        true,
      isLuckyDrawSip: Boolean(
        item?.sipplanDetails?.enableLuckyDraw ??
          item?.enableLuckyDraw ??
          item?.luckyDrawDetails?.enableLuckyDraw
      ),
    };
  });

  const columns = [
    { field: "id", headerName: "Id", hide: true },
    { field: "createdAt", headerName: "Created At" },
    {
      field: "Number",
      headerName: "Book Number",
      render: (value, row) => <span>{row.Number ? row.Number : "N.A"}</span>,
    },
    { field: "sipplanname", headerName: "Plan Name" },
    { field: "choiceNumber", headerName: "Choice Number" },
    { field: "serialNumber", headerName: "Serial Number" },
    { field: "name", headerName: "Name" },
    { field: "phone", headerName: "Phone" },
    { field: "address", headerName: "Address" },
    { field: "metalPurity", headerName: "Metal (Purity)" },
    { field: "amount", headerName: "Installment Amount" },
    { field: "months", headerName: "Months" },
    { field: "paidInstallments", headerName: "Paid" },
    { field: "pending", headerName: "Pending" },
    { field: "lastPaid", headerName: "Last Paid" },
    { field: "Upcoming", headerName: "Upcoming" },
    {
      field: "status",
      headerName: "Status",
      render: (val) => {
        let color = "#6c757d";
        if (val === "COMPLETED") color = "green";
        else if (val === "PENDING" || val === "RUNNING") color = "orange";
        else if (val === "CANCELLED") color = "red";

        return (
          <span style={{ color, fontWeight: 600, textTransform: "capitalize" }}>
            {val?.toLowerCase()}
          </span>
        );
      },
    },
    {
      field: "luckyDrawEligibility",
      headerName: "Lucky Draw Eligibility",
      minWidth: 220,
      render: (val, row) => {
        if (!row?.isLuckyDrawSip) return <span>N.A</span>;
        const isChecked = val !== false;
        return (
          <Switch
            checked={isChecked}
            onChange={(event) =>
              handleLuckyDrawEligibilityChange(
                row._id,
                event.target.checked
              )
            }
            color="primary"
          />
        );
      },
    },
    {
      field: "Details",
      headerName: "View Details",
      render: (val, row) => (
        <button
          style={{
            backgroundColor: "#ffc107",
            color: "#000",
            border: "none",
            padding: "5px 10px",
            borderRadius: "4px",
            cursor: "pointer",
          }}
          onClick={() => handleViewInstallments(row._id)}
        >
          View
        </button>
      ),
    },
  ];

  return (
    <Box sx={{ width: "100%", height: "100vh", overflow: "auto" }}>
      <Box
        sx={{
          width: "100%",
          mt: { xs: 10, md: 10 },
          background: "#fff",
          borderRadius: "16px",
          mb: 2,
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }}
      >
        <Typography fontWeight={700} fontSize={24} p={2} fontFamily={"Aeonik"}>
          Sip List
        </Typography>

        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Box
            display="flex"
            flexDirection={isMobile ? "column" : "row"}
            alignItems="center"
            gap={2}
            p={2}
          >
            <DatePicker
              label="Select Start Date"
              value={startDate}
              onChange={setStartDate}
              sx={{ minWidth: { xs: "210px", sm: "332px" } }}
              renderInput={(params) => <TextField size="small" {...params} />}
            />
            <DatePicker
              label="Select End Date"
              value={endDate}
              onChange={setEndDate}
              sx={{ minWidth: { xs: "210px", sm: "332px" } }}
              renderInput={(params) => (
                <TextField size="small" {...params} fullWidth />
              )}
            />
            <button
              onClick={handleFilter}
              style={{
                backgroundColor: "#752ADA",
                color: "#fff",
                border: "none",
                padding: "8px 16px",
                borderRadius: "6px",
                cursor: "pointer",
                height: "55px",
                fontSize: "16px",
              }}
            >
              Get Details
            </button>
          </Box>
        </LocalizationProvider>

        {/* Table Section */}
        <CardContent sx={{ height: "580px", width: "100%" }}>
          <TableCompo
            columns={columns}
            data={
              displayData.length > 0
                ? displayData
                : [{ id: "no-data", name: "No data available" }]
            }
            totalCount={total}
            loading={loading}
            page={pagination.page}
            limit={pagination.limit}
            onTableChange={handleTableChange}
          />
        </CardContent>
      </Box>

      {/* Dialog Section */}
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          Installment Details
          <IconButton onClick={handleCloseDialog} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          {loading ? (
            <Typography>Loading...</Typography>
          ) : sipInstallments?.sipInstallments?.length > 0 ? (
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Installment #</TableCell>
                  <TableCell>Installment Date</TableCell>
                  <TableCell>Paid Amount</TableCell>
                  <TableCell>Paid At</TableCell>
                  <TableCell>Paid Mode</TableCell>
                  <TableCell>Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {sipInstallments.sipInstallments.map((installment, index) => (
                  <TableRow key={index}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>
                      {installment.installmentDate
                        ? new Date(
                            installment.installmentDate
                          ).toLocaleDateString()
                        : "N.A"}
                    </TableCell>
                    <TableCell>
                      {installment.totalPaidAmount != null && installment.totalPaidAmount !== ''
                        ? Number(installment.totalPaidAmount).toFixed(2)
                        : '-'}
                    </TableCell>
                    <TableCell>
                      {installment.createdAt
                        ? new Date(installment.createdAt).toLocaleDateString()
                        : "N.A"}
                    </TableCell>
                    <TableCell>{installment.paymentMode ?? "N.A"}</TableCell>
                    <TableCell>{installment.status ?? "N.A"}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          ) : (
            <Typography variant="body2">
              No installment data available.
            </Typography>
          )}
        </DialogContent>
      </Dialog>
    </Box>
  );
}
